import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/About';
import Contact from './Pages/Contact';
import SeoServices from './Pages/SeoServices';
import Career from './Pages/Career';
import JobApply from './Pages/JobApply';
import PosSoftware from './Pages/PosSoftware';
import Checkout from './Pages/Checkout';
import DomainSelection from './Pages/DomainSelection';
import Layout from './Layout/Layout';
import "./App.css"
import "./Responsive.css"
import Faq from './Pages/Faq';
import ServicesPage from './Pages/Services';
import SingleServiceCategory from './Pages/SingleCategoryDetail';
import ServiceDetailPage from './Pages/ServicesDetails';


const Loader = () => (
  <div className="preloader" id="preloader">
    <div className="preloader-inner">
      <div className="spinner">
        <div className="dot1"></div>
        <div className="dot2"></div>
      </div>
    </div>
  </div>
);
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}


function App() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <React.Fragment>
      {/* {loading && <Loader />} */}
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<Layout><Home /></Layout>} />
          <Route path="/about-us" element={<Layout><About /></Layout>} />
          <Route path='/services' element={<Layout><ServicesPage /></Layout>} />
          <Route path="/services/:category" element={<Layout><SingleServiceCategory /></Layout>} />
          <Route path="/services/:category/:serviceSlug" element={<Layout><ServiceDetailPage /></Layout>} />
          <Route path='/faqs' element={<Layout><Faq /></Layout>} />
          <Route path='/contact' element={<Layout><Contact /></Layout>} />
          
          <Route path='/service-detail-design-2' element={<Layout><SeoServices /></Layout>} />
          <Route path='/service-detail-design' element={<Layout><PosSoftware /></Layout>} />
          <Route path='/career' element={<Career />} />
          <Route path='/checkout' element={<Checkout />} />
          <Route path='/career/job-apply' element={<JobApply />} />
          <Route path='/domain-selection' element={<DomainSelection />} />
          {/* <Route path='*' element={<Error404 />} /> */}
        </Routes>
    </React.Fragment>
  );
}

export default App;
